import { render, staticRenderFns } from "./ActionPremiumRating.vue?vue&type=template&id=5c7e3be9&scoped=true"
import script from "./ActionPremiumRating.vue?vue&type=script&lang=js"
export * from "./ActionPremiumRating.vue?vue&type=script&lang=js"
import style0 from "./ActionPremiumRating.vue?vue&type=style&index=0&id=5c7e3be9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7e3be9",
  null
  
)

export default component.exports